import React, { useEffect, useState } from "react";
import { Card, Col, Dropdown, Row } from "react-bootstrap";
import search from "../../assets/search.svg";
import TopNavBar from "../Layout/TopNavBar";
import { Space, Table, Tag, Button } from "antd";
import CustomTable from "../Common/customeTable";
import { tableColumnOptionIcon } from "../Common/optionIcon";
import { showAlert, showError, showSuccess } from "../utills/sweetAlert";
import { callApi } from "../utills/api";
import { useNavigate } from "react-router-dom";
import { PlusOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import ReactPaginate from "react-paginate";
import { Hourglass } from "react-loader-spinner";

const MainDashboard = () => {
    const navigate = useNavigate();
    const [dashBoardDetails, setDashBoardDetails] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
   

    useEffect(() => {
        getDashboardData();
    }, []);

    const getDashboardData = () => {
      setLoading(true);
        callApi("GET", "sectionSelect.php", "")
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    setDashBoardDetails(response.data);
          setLoading(false);

                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearch = (term: string) => {
        setSearchTerm(term);
    };

    const filteredData = dashBoardDetails.filter((item: any) =>
        Object.values(item).some((value) =>
            (value as string).toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    // Calculate pagination for filtered data
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const offset = currentPage * itemsPerPage;
    const currentData = filteredData.slice(offset, offset + itemsPerPage);
    const handlePageClick = (event: { selected: number }) => {
        setCurrentPage(event.selected);
    };

    // Calculate the display range for the items
    const startItem = offset + 1;
    const endItem = Math.min(offset + itemsPerPage, filteredData.length);


    const addPage = () => {
         navigate('/layout/dashboard')
    }

    const editPage = (masterId:any,subId:any) => {
        console.log("masterId--->",masterId);
        console.log("subId--->",subId);
        navigate('/layout/dashboard', { state: { masterId: masterId, subId:subId } });
        
   }
    const data: any = dashBoardDetails ?? [];

    const deleteApi = async (masterId: any,subId:any) => {
        const isComfirm = await showAlert(
            "Please Confirm",
            `Are you sure you want to Delete ?`,
            "Yes",
            "No"
        );
        if (isComfirm) {
            let req = {
                masterId: masterId,
                subId:subId
            };
            callApi("POST", "sectionDelete.php", req)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        showSuccess("Success!", "Page Deleted Successfully!");

                        getDashboardData();
                    }
                })
                .catch((err: any) => {
                    console.error(
                        "API call error:",
                        err.response ? err.response.data.error : err.message
                    );
                    showError(
                        "Failed",
                        err.response ? err.response.data.error : err.message
                    );
                });
        }
    }
    
    return (
        <>
            <div className="mobile_nav_bar">
                <TopNavBar />
            </div>
            <div className='mblcontent'>
                <Row className='webview'>
                    <div className="category-header">
                        <Col lg="7" md="7" >
                            <h3 className="category-title">
                                Pages
                            </h3>
                        </Col>
                        <Col lg="5" md="5" className="headbtn " >
                <button className="cashinbtn"
                onClick={addPage}>
Add Page
                </button>
                            <div className="search-bar">
                                <img
                                    src={search}
                                    alt="search-icon"
                                    style={{ width: "22px" }}
                                />
                               <input type="text" placeholder="Search..."
                               onChange={(e) => handleSearch(e.target.value)} />
                       </div>
                        </Col>
                    </div>
                </Row>
                <Row className='mblview mbldashboard'>
                    <div className="category-header">

                        <Col lg="8" md="8">
                            <h3 className="category-title">
                                Pages
                            </h3>
                        </Col>
                        <div className='mblcol'>

                        </div>
                        <Col lg="2" md="2">
                        <div className="search-bar">
                                    <img
                                        src={search}
                                        alt="search-icon"
                                        style={{ width: "22px" }}
                                    />
                                    <input type="text" placeholder="Search..."
                                        onChange={(e) => handleSearch(e.target.value)} />
                                </div>
                        </Col>
                    </div>
                </Row>

                <div className="element-container">
              
                    {filteredData.length > 0 ? (
                        <div className="table-container">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Master Name</th>
                                        <th>Sub-Category Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>
                                            {offset + index + 1}
                                            </td>
                                            <td className='boldtd'>{item.masterName}</td>
                                            <td>
                                                <span >
                                                    {item.subName}
                                                </span>
                                            </td>
                                           
                                            <td>
                                                <div className='webview'>
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle
                                                            variant="link"
                                                            id="dropdown-basic"
                                                            style={{ border: "none", background: "transparent" }}
                                                        ></Dropdown.Toggle>
                                                        <Dropdown.Menu
                                                            id="webdropdown">
                                                            <Dropdown.Item
                                                                onClick={() => editPage(item.masterId,item.subId)}
                                                            >
                                                                Edit
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => deleteApi(item.masterId,item.subId)}
                                                            >
                                                                Delete
                                                            </Dropdown.Item>
                                                           
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                                <div className='mblview'>
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle
                                                            variant="link"
                                                            id="dropdown-basic"
                                                            style={{ border: "none", background: "transparent" }}
                                                        ></Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                // onClick={() => handleEdit(item.id)}
                                                            >
                                                                Edit
                                                            </Dropdown.Item>
                                                          
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="pagination-container">
                                <div className="pagination-info">
                                    {`${startItem} - ${endItem} of ${filteredData.length}`}
                                </div>
                                <ReactPaginate
                                    previousLabel={'<'}
                                    nextLabel={'>'}
                                    breakLabel={'...'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    activeClassName={'active-page'}
                                    pageClassName={'page-item'}
                                    previousClassName={'prev-next'}
                                    nextClassName={'prev-next'}
                                />
                            </div>
                        </div>
                    ) : (
                        <p className='nodata'>Data Not Found</p>
                    )}
                </div>
            </div>

            {loading && (
        <div className="loader-overlay">
          <div className="loader-container">
            <Hourglass visible={true} height={50} width={50} />
          </div>
        </div>
      )}
        </>
    );
};

export default MainDashboard;
